import { GlassCard } from "@/components/GlassCard";
import { fmtUSDcents } from "@/lib/format";
import { Flame, Trophy } from "lucide-react";

export function StreakBestDay({ data }) {
  if (!data) return null;
  const streak = data.longest_streak || 0;
  const best = data.best_day;
  const [y, m, d] = best?.date ? best.date.split("-") : [];
  const bestLabel = best?.date
    ? new Date(Number(y), Number(m) - 1, Number(d)).toLocaleDateString("en-US", { month: "short", day: "numeric" })
    : "—";

  return (
    <GlassCard data-testid="streak-best-day">
      <div className="grid grid-cols-2 gap-4">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-2xl glass-pill flex items-center justify-center flex-shrink-0">
            <Flame className="w-5 h-5 text-orange-300" strokeWidth={2.2} />
          </div>
          <div className="min-w-0">
            <p className="text-[10px] font-semibold uppercase tracking-widest text-white/50">Longest Streak</p>
            <p className="font-heading text-2xl font-bold text-white mt-1 tabular-nums leading-none">
              {streak}
              <span className="text-sm font-medium text-white/55 ml-1">
                day{streak === 1 ? "" : "s"}
              </span>
            </p>
            <p className="text-xs text-white/50 mt-1">Consecutive worked</p>
          </div>
        </div>

        <div className="flex items-start gap-3 border-l border-white/15 pl-4">
          <div className="w-10 h-10 rounded-2xl glass-pill flex items-center justify-center flex-shrink-0">
            <Trophy className="w-5 h-5 text-amber-300" strokeWidth={2.2} />
          </div>
          <div className="min-w-0">
            <p className="text-[10px] font-semibold uppercase tracking-widest text-white/50">Best Day</p>
            <p className="font-heading text-2xl font-bold text-white mt-1 tabular-nums leading-none truncate">
              {best ? fmtUSDcents(best.total) : "$0"}
            </p>
            <p className="text-xs text-white/50 mt-1">{bestLabel}</p>
          </div>
        </div>
      </div>
    </GlassCard>
  );
}
